import { FC } from "react";
import { Loader2 } from "lucide-react";

type LoadingProps = {
  size?: number | string;
  className?: string;
  label?: string;
};

const Loading: FC<LoadingProps> = ({ size = 32, className = "", label }) => (
  <div className="flex items-center justify-center gap-2">
    <Loader2
      className={["animate-spin text-ink", className].filter(Boolean).join(" ")}
      size={size as number}
      strokeWidth={2.5}
    />
    {label && <span className="text-ink text-sm">{label}</span>}
  </div>
);

export default Loading;

